import logger from '../../../log/logger';

/**
 * 자동완성 키워드와 일치하는 검색키워드를 찾아 반환합니다.
 * 테스트 코드를 참고하여 일치 조건을 확인할 수 있습니다.
 */
export function getMatchedKeyword({
  searchKeyword,
  autoCompleteKeyword,
}: {
  searchKeyword: string;
  autoCompleteKeyword: string;
}) {
  let result = undefined;
  try {
    const regex = new RegExp(
      searchKeyword
        .replace(/ /g, '')
        .split('')
        .map((text, index, arr) => {
          const _text = SPECIAL_CHARACTER_REGEX.test(text) ? `\\${text}` : text;
          if (index === arr.length - 1) {
            return _text;
          }
          return _text.concat('\\s?');
        })
        .join(''),
      'i'
    );
    result = regex.exec(autoCompleteKeyword);
  } catch (e) {
    logger.err(`검색 RegExp 생성 및 검사 에러 keyword: ${searchKeyword}`, e);
  }
  if (!result) {
    return;
  }

  return result && result[0];
}

const SPECIAL_CHARACTER_REGEX = /[^\w|ㄱ-ㅎ|ㅏ-ㅣ|가-힣|\s]/i;
